"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.environmentNames = void 0;
var environmentNames;
(function (environmentNames) {
    environmentNames["TEST"] = "test";
    environmentNames["DEVELOP"] = "develop";
    environmentNames["STAGING"] = "staging";
    environmentNames["PROD_US"] = "prod-us";
    environmentNames["PROD_UK"] = "prod-uk";
})(environmentNames || (exports.environmentNames = environmentNames = {}));
